import { observer } from 'mobx-react';
import { FC } from 'react';
import ApplePayDomain from '../ApplePayDomain/ApplePayDomain';
import './style.scss';
import { IApplePayDomain } from '../../types/applePay';

interface IPropsApplePayDomains {
  domains: IApplePayDomain[];
}

const ApplePayDomains: FC<IPropsApplePayDomains> = ({ domains }: IPropsApplePayDomains): JSX.Element | null => {
  if (domains.length === 0) {
    return null;
  }

  return (
    <div className="apple-pay-settings-domains">
      {domains.map((domain, index) => (
        <ApplePayDomain key={index} domain={domain} />
      ))}
    </div>
  );
};

export default observer(ApplePayDomains);
